import * as React from 'react' ;
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TabsComponent from './tabs-component';
import Pane from './pane/pane-container';

class TabsContainer extends React.Component {

	constructor(props) {
		super(props);

		this.state = {selected: props.selected || 0}

		this.handleTabClick = this.handleTabClick.bind(this);
		this._setSelected = this._setSelected.bind(this);
	}

	componentWillMount() {
		this._setSelected(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this._setSelected(nextProps);
	}

	handleTabClick(index, event) {
		this.setState({selected: index});
	}

	render() {
		return <TabsComponent {...this.props} onTabClick={this.handleTabClick} selected={this.state.selected} />;
	}

	_setSelected(props) {
		const hash = props.location.hash.substring(1);
		const numOfPanes = React.Children.count(props.children)
		let selected = 0

		if (numOfPanes > 1) {
			props.children.forEach((tabItem, index) => {
				if (!tabItem) return
				if (tabItem.props.id === hash) selected = index
			});
		}

		this.setState({ selected });
	}

}

export default withRouter(TabsContainer);

TabsContainer.propTypes = {
	children: getChildrenPropType,
	singled: PropTypes.bool
}

function getChildrenPropType(props, propName, componentName) {
	const prop = props[propName];
	const propIsArray = Array.isArray(prop);

	if (propIsArray) {
		for (let i = 0; i < prop.length; i++) {
			const item = prop[i];
			if (!item.type || Pane !== item.type) {
				return new Error(
					'Invalid prop `' + propName + '` supplied to' +
					' `' + componentName + '`. Expected array of' +
					' `Pane` components or single `Pane`' +
					' component but array with one `' + typeof item + '`' +
					' received.'
				);
			}
		}
	} else if (!prop.type || Pane !== prop.type) {
		return new Error(
			'Invalid prop `' + propName + '` supplied to' +
			' `' + componentName + '`. Expected array of' +
			' `Pane` components or single `Pane`' +
			' component but `' + (typeof prop) + '`received.'
		);
	}
}


// WEBPACK FOOTER //
// ./src/component/tabs/tabs-container.js